import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/cn.js';
const KIND_RULE = {
    draft: 'border-s-[var(--color-accent)]',
    action: 'border-s-[var(--color-sage)]',
    propose: 'border-s-[var(--color-accent)]',
    approve: 'border-s-[var(--color-sage)]',
    edit: 'border-s-[var(--color-steel)]',
    security: 'border-s-[var(--color-rose)]',
    watch: 'border-s-[var(--color-accent)]',
    system: 'border-s-[var(--color-ink-muted)]',
};
const KIND_LABEL_COLOR = {
    draft: 'text-[var(--color-accent)]',
    action: 'text-[var(--color-sage)]',
    propose: 'text-[var(--color-accent)]',
    approve: 'text-[var(--color-sage)]',
    edit: 'text-[var(--color-steel)]',
    security: 'text-[var(--color-rose)]',
    watch: 'text-[var(--color-accent)]',
    system: 'text-[var(--color-ink-muted)]',
};
export function AuditRow({ timestamp, actor, actorAvatar, action, target, meta, kind, className, }) {
    return (_jsxs("div", { className: cn('grid grid-cols-[60px_140px_100px_1fr_1fr] items-baseline gap-3 border-s-2 border-b border-b-[var(--color-line)] bg-[var(--color-surface)] px-3 py-2.5 text-[12.5px] last:border-b-0', KIND_RULE[kind], className), children: [_jsx("span", { className: "font-mono text-[var(--color-ink-muted)]", children: timestamp }), _jsxs("span", { className: "inline-flex items-center gap-2 text-[var(--color-ink-secondary)]", children: [actorAvatar !== undefined && (_jsx("span", { "aria-hidden": true, className: "inline-flex size-5 items-center justify-center rounded-[var(--r-1,4px)] border border-[var(--color-line-2)] bg-[var(--color-surface-2)] text-[10px] text-[var(--color-ink-muted)]", children: actorAvatar })), actor] }), _jsx("span", { className: cn('font-mono text-[10.5px] uppercase tracking-[0.08em]', KIND_LABEL_COLOR[kind]), children: action }), _jsx("span", { className: "text-[var(--color-ink)]", children: target }), _jsx("span", { className: "text-[var(--color-ink-muted)]", children: meta })] }));
}
